<template>
    <div>
      <Pos_paper_tax_invoices_sale/>
    </div>
  </template>
  
  <script>
  import Pos_paper_tax_invoices_sale from "@/components/adminArin/pos_system/pos/Pos_paper_tax_invoices_sale";
  export default {
    name: "PosPaperTaxInvoicesSale",
    components: {
      Pos_paper_tax_invoices_sale
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  